module.exports = __webpack_public_path__ + "website/img/Yoyo_C_02.b6abe12e.jpeg";